module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    attrs: {
      "light": ""
    }
  }, [_c('v-navigation-drawer', {
    attrs: {
      "fixed": "",
      "app": "",
      "right": "",
      "temporary": ""
    },
    model: {
      value: (_vm.drawer),
      callback: function($$v) {
        _vm.drawer = $$v
      },
      expression: "drawer"
    }
  }, [_c('v-list', [_c('v-list-tile', {
    attrs: {
      "router": "",
      "to": "/",
      "exact": ""
    }
  }, [_c('v-list-tile-action', [_c('v-icon', {
    attrs: {
      "light": ""
    }
  }, [_vm._v("home")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Home")])], 1)], 1), _vm._v(" "), (_vm.userIsAuthenticated) ? _c('v-list-tile', {
    attrs: {
      "router": "",
      "to": "/settings"
    }
  }, [_c('v-list-tile-action', [_c('v-icon', {
    attrs: {
      "light": ""
    }
  }, [_vm._v("settings")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Settings")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-divider', {
    staticClass: "mt-5 mb-2"
  }), _vm._v(" "), (_vm.userIsAuthenticated) ? _c('v-list-tile', {
    attrs: {
      "router": ""
    },
    on: {
      "click": _vm.onLogout
    }
  }, [_c('v-list-tile-action', [_c('v-icon', {
    attrs: {
      "light": ""
    }
  }, [_vm._v("exit_to_app")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Log Out")])], 1)], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-toolbar', {
    attrs: {
      "fixed": "",
      "app": "",
      "color": "secondary",
      "dark": ""
    }
  }, [(_vm.userIsAuthenticated) ? _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.goBack.apply(null, arguments)
      }
    }
  }, [_c('v-icon', [_vm._v("arrow_back")])], 1) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-toolbar-title', {
    domProps: {
      "textContent": _vm._s(_vm.title)
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../static/img/cubo-icon.png"),
      "width": "50"
    }
  }), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.userIsAuthenticated) ? _c('v-toolbar-side-icon', {
    attrs: {
      "right": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = !_vm.drawer
      }
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.templates.length > 20 && _vm.oldTemplates.length > 10) ? _c('v-content', [_c('router-view')], 1) : _c('v-content', [_c('v-progress-linear', {
    attrs: {
      "indeterminate": _vm.templates < 1,
      "query": true
    },
    model: {
      value: (_vm.templates.length),
      callback: function($$v) {
        _vm.$set(_vm.templates, "length", $$v)
      },
      expression: "templates.length"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "text-xs-center display-1"
  }, [_vm._v(_vm._s('Downloading Job Templates'))]), _vm._v(" "), _c('v-progress-linear', {
    attrs: {
      "indeterminate": _vm.templates < 1,
      "query": true
    },
    model: {
      value: (_vm.templates.length),
      callback: function($$v) {
        _vm.$set(_vm.templates, "length", $$v)
      },
      expression: "templates.length"
    }
  })], 1), _vm._v(" "), _c('update-dialog', {
    attrs: {
      "dialog": _vm.newVersion
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-449df026","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 668
// module chunks = 1